
import {IEnumListEntry} from "../definitions";

export const SCENE_TYPES = {
  DIALOG:0,
  HINT_DIALOG:1,
  REWARD_DIALOG:2,
  COMICS:3,
  STATE_DIALOG:4
};

export const SLIDES_TRANSITION_TYPES ={
  NONE:0,
  SIMPLE:1
};

export const CHARACTERS = {
  NONE:-1,
  SHMU: 1,
  KAYA: 2,
  CAT: 3,
  CAPTAIN: 4,
  SHMU_FARMER: 5
};

export const EMOTIONS = {
  IDLE:0,
  LAUGHING:1,
  HAPPY:2,
  SURPRIZED:3,
  DISPLEASED:4,
  THINKING:5,
  PANIC:6,
  SAD:7
};

export const SLIDES_TRANSITIONS_TYPES_LIST:IEnumListEntry[] =[
  {id:SLIDES_TRANSITION_TYPES.NONE, label:"Нет"},
  {id:SLIDES_TRANSITION_TYPES.SIMPLE, label:"Простой"}
];

export const SCENE_TYPES_LIST:IEnumListEntry[] = [
  {id: SCENE_TYPES.DIALOG, label:"Диалог"},
  {id: SCENE_TYPES.HINT_DIALOG, label:"Диалог с подсказкой"},
  {id: SCENE_TYPES.REWARD_DIALOG, label:"Диалог с наградой"},
  {id: SCENE_TYPES.COMICS, label:"Комикс"},
  {id: SCENE_TYPES.STATE_DIALOG, label:"Диалог со стейтом"}
];

export const SCENE_CHARACTERS_LIST:IEnumListEntry[] = [
  {id: CHARACTERS.NONE, label:"Нет"},
  {id: CHARACTERS.SHMU, label:"Шму"},
  {id: CHARACTERS.KAYA, label:"Кая"},
  {id: CHARACTERS.CAT, label:"Кот"},
  {id: CHARACTERS.CAPTAIN, label:"Капитан"},
  {id: CHARACTERS.SHMU_FARMER, label:"Шму фермер"}
];

export const CHAR_EMOTIONS_LIST:IEnumListEntry[] = [
  {id: EMOTIONS.IDLE, label:"Без эмоций"},
  {id: EMOTIONS.LAUGHING, label:"Смех"},
  {id: EMOTIONS.HAPPY, label:"Счастье"},
  {id: EMOTIONS.SURPRIZED, label:"Удивление"},
  {id: EMOTIONS.DISPLEASED, label:"Недовольство"},
  {id: EMOTIONS.THINKING, label:"Задумчивость"},
  {id: EMOTIONS.PANIC, label:"Паника"},
  {id: EMOTIONS.SAD, label:"Грусть"}
];



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-scene-types.ts